import { marked } from "@enersis/gp-components/gp-markdown";
import { CrmModule } from "src/app/core/enums/permissions";

export class GlossaryItem {
  title: string;
  content: string;
  tags: Array<CrmModule>;
}

export interface RegulatedGlossaryDto {
  moduleKnowledge: Array<GlossaryItem>;
  definitions: Array<GlossaryItem>;
}

export class RegulatedGlossary {
  constructor(readonly moduleKnowledge: Array<GlossaryItem>, readonly definitions: Array<GlossaryItem>) {}

  static fromDto(dtos: RegulatedGlossaryDto): RegulatedGlossary {
    return new RegulatedGlossary(dtos.moduleKnowledge, dtos.definitions);
  }
}

export interface MarketplaceGlossaryDto {
  explanationOfTerms: string;
  calculationLogic: string;
  datasources: string;
}

export class MarketplaceGlossary {
  constructor(
    readonly explanationOfTermsStr: string,
    readonly calculationLogicStr: string,
    readonly datasourcesStr: string
  ) {}

  static fromDto(dto: MarketplaceGlossaryDto): MarketplaceGlossary {
    return new MarketplaceGlossary(dto.explanationOfTerms, dto.calculationLogic, dto.datasources);
  }

  get explanationOfTerms(): Array<GlossaryItem> {
    return this.toItems(this.explanationOfTermsStr);
  }

  get calculationLogic(): Array<GlossaryItem> {
    return this.toItems(this.calculationLogicStr);
  }

  get datasources(): Array<GlossaryItem> {
    return this.toItems(this.datasourcesStr);
  }

  /**
   * Convert markdown text to array of GlossaryItem
   * @param text - Markdown text
   * @returns Array of GlossaryItem
   */
  private toItems(text: string): Array<GlossaryItem> {
    const htmlStr = marked(text);
    const splittedHtml = htmlStr
      .replace(/<hr>/g, "")
      .replace(/<br>/g, "")
      .split(/<h3[^>]*>/);
    return splittedHtml
      .filter((item) => item.trim() !== "")
      .map((item) => {
        const [title = "", content = ""] = item.split(/<\/h3>/);
        return { title: title.trim(), content: content.trim(), tags: [] };
      });
  }
}
